import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers";
import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas";
import { routerMiddleware } from "connected-react-router";
import history from "../lib/history";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createEncryptor from "redux-persist-transform-encrypt";

const encryptor = createEncryptor({ secretKey: process.env.REACT_APP_ENC_KEY });

const persistConfig = {
  key: "root",
  storage,
  transforms: [encryptor],
  blacklist: [""],
  whitelist: ["Auth"],
};

const sagaMiddleware = createSagaMiddleware();

// Logger middleware
const logger = createLogger({
  predicate: (getState, action) => !!process.env.NODE_ENV,
});

const connectedRouterMiddleware = routerMiddleware(history);
const persistedReducer = persistReducer(persistConfig, reducers);
const initialStore = {};
let middlewares = [sagaMiddleware];

if (!process.env.IS_SERVER) {
  middlewares.push(connectedRouterMiddleware);
}

const enhancers = [composeWithDevTools(applyMiddleware(...middlewares))];
const store = createStore(persistedReducer, initialStore, compose(...enhancers));

sagaMiddleware.run(rootSaga);
store.asyncReducers = {};
const persistor = persistStore(store);

export { store, persistor };
